"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectedSimilarProductService = void 0;
class SelectedSimilarProductService {
}
exports.SelectedSimilarProductService = SelectedSimilarProductService;
SelectedSimilarProductService.isLetResellerRecommends = (selectedSimilarProduct) => {
    return selectedSimilarProduct === 're';
};
SelectedSimilarProductService.isProductItem = (selectedSimilarProduct) => {
    return (selectedSimilarProduct != null &&
        Object.keys(selectedSimilarProduct).includes('sku') &&
        selectedSimilarProduct.sku != null);
};
